// extracted by mini-css-extract-plugin
module.exports = {"item":"TickList_item__2H_QU","check":"TickList_check__3APhG"};